import type Result from './Result'

import { LoadedOrganization } from '../../../Foobara/Commandforge/Types/Organization/Loaded'

export default function castJsonResult (json: any): Result {
  json = new LoadedOrganization(json)
  return json
}
